import { Box, Grid } from "@mui/material";
import React, { useRef } from "react";

import utilsService from "../../../../../services/fileUpload";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../../../../redux/store";
import { setLoadingAction } from "../../../../../redux/utils/actions";
import Button from "../../../../common/Button";
import styles from "./../../../../common/fileUploadButton/styles.module.css";
import ImageAsset from "../ImageAsset";
import { Clear, CropSquareSharp } from "@mui/icons-material";
import config from "../../../../../config";

interface FileUploadButtonProps {
  name: string;
  multiple?: boolean;
  callBack: (data: string[]) => void;
  documentTitle?: string;
}

const BillUploadButton: React.FC<FileUploadButtonProps> = ({
  name,
  multiple = true,
  callBack,
  documentTitle = "Bill document",
}) => {
  //   const { values, touched, errors, setFieldValue } = useFormikContext<FormikValues>();
  const [files, setFiles] = React.useState<string[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);

  const dispatch = useAppDispatch();

  const getFileExtension = (link: string) => {
    const re = /(?:\.([^.]+))?$/;
    return re.exec(link)?.[1];
  };

  const handleFileUpload = async (
    e: React.ChangeEvent<HTMLInputElement>
  ): Promise<void> => {
    e.preventDefault();
    if (!e.target.files) return;

    try {
      dispatch(setLoadingAction(true));
      const { data }: { data: { data: string[] } } = await utilsService.upload(
        e.target.files
      );
      dispatch(setLoadingAction(false));
      const imageUrlGrid: string[] = data?.data || [];
      setFiles((prev: string[]) => {
        const nextData = [...imageUrlGrid, ...prev];
        callBack?.(nextData);
        return nextData;
      });
    } catch (err: any) {
      toast.error(err.response.data.msg);
      dispatch(setLoadingAction(false));
    }
  };

  //   const handleFileDelete = async (reversedIndex: number) => {
  //     const originIndex = +values?.[name]?.length - 1 - reversedIndex;
  //     const data = values?.[name][originIndex];
  //     const prevData = [...values[name]];
  //     const filteredData = prevData.filter((_, i) => i !== originIndex);
  //     setFieldValue(name, filteredData);
  //     if (inputRef.current != null) {
  //       inputRef.current.value = "";
  //     }
  //     try {
  //       await utilsService.deleteFile({ url: data.path });
  //     } catch (err) {
  //       logger.error("File Delete failed");
  //     }
  //   };

  const deleteUploadedFile = async () => {
    try {
      for (const file of files) {
        await utilsService.deleteFile({ url: file });
      }
      setFiles([]);
      callBack([]);
    } catch (err) {
      console.error("File Delete failed", err);
    }
  };

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    } else {
      alert("other");
    }
  };

  return (
    <Box className={styles.uploadContainer} style={{ minHeight: "50px" }}>
      {
        <div style={{ margin: "20px 0" }}>
          <input
            type="file"
            accept="image/png, image/jpeg, application/pdf"
            className={styles.fileUploadInput}
            ref={inputRef}
            placeholder={"Upload file..."}
            name={name}
            onChange={handleFileUpload}
            multiple={multiple}
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              color="alert"
              type="button"
              className="mr-12"
              onClick={handleClick}
            >
              <ArrowUpwardIcon /> Upload
            </Button>

            <Button
              type="button"
              className="mr-12"
              onClick={deleteUploadedFile}
            >
              <Clear /> Clear Uploaded file
            </Button>
          </div>
        </div>
      }
      {files.length > 0 && (
        <div className="mb-16">
          <div style={{ height: "170px", display: "flex", gap: "10px", overflow: 'scroll' }}>
            {files?.map((cardUrl: string) => (
              <div>
                <ImageAsset
                key={cardUrl}
                  imgUrl={cardUrl}
                  title={documentTitle}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </Box>
  );
};

export default BillUploadButton;
